// extracted by mini-css-extract-plugin
export default {"emptyIcon":"emptyIcon--pjHar"};